import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../../shared/services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button 
      class="theme-toggle-btn"
      (click)="toggleTheme()"
      [attr.aria-label]="'Switch to ' + getNextThemeLabel() + ' theme'"
      [title]="'Current: ' + themeService.getThemeLabel() + ' theme. Click to switch to ' + getNextThemeLabel()">
      <span class="theme-icon">{{ getThemeIcon() }}</span>
      <span class="theme-label">{{ themeService.getThemeLabel() }}</span>
    </button>
  `,
  styles: [`
    .theme-toggle-btn {
      display: flex;
      align-items: point;
      gap: var(--spacing-sm);
      background: var(--color-surface);
      border: 1px solid var(--color-border);
      border-radius: var(--bradius-m);
      padding: var(--spacing-sm) var(--spacing-m);
      color: var(--color-text-primary);
      cursor: pointer;
      transition: all 0.2s ease;
      font-family: inherit;

      font-weight: 500;
      min-width: 90px;
      
      &:hover {
        background: var(--color-surface-variant);
        border-color: var(--color-border-strong);
        transform: translateY(-1px);
        box-shadow: var(--shadow-light);
      }
      
      &:active {
        transform: translateY(0);
        box-shadow: none;
      }
      
      &:focus {
        outline: none;
        box-shadow: var(--shadow-focus);
      }
    }
    
    .theme-icon {

      line-height: 1;
      filter: var(--filter-text-primary);
    }
    
    .theme-label {

      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    /* Compact version */
    .theme-toggle-btn.compact {
      min-width: auto;
      padding: var(--spacing-s);
      
      .theme-label {
        display: none;
      }
    }

    /* Icon-only version */
    .theme-toggle-btn.icon-only {
      min-width: 40px;
      padding: var(--spacing-sm);
      
      .theme-label {
        display: none;
      }
    }
  `]
})
export class ThemeToggleComponent {
  themeService = inject(ThemeService);

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  getThemeIcon(): string {
    switch (this.themeService.currentTheme()) {
      case 'light':
        return '☀️';
      case 'dark':
        return '🌙';
      case 'auto':
        return '🔄';
      default:
        return '🔄';
    }
  }

  getNextThemeLabel(): string {
    switch (this.themeService.currentTheme()) {
      case 'light':
        return 'Dark';
      case 'dark':
        return 'Auto';
      case 'auto':
        return 'Light';
      default:
        return 'Light';
    }
  }
}
